import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from 'firebase/analytics';

// Only initialize Analytics if all required config values are present
const hasAllConfig = 
    process.env.REACT_APP_FIREBASE_API_KEY &&
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN &&
    process.env.REACT_APP_FIREBASE_PROJECT_ID &&
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET &&
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID &&
    process.env.REACT_APP_FIREBASE_APP_ID;

let app = null;
let analytics = null;

if (hasAllConfig && typeof window !== 'undefined') {
    try {
        const firebaseConfig = {
            apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FIREBASE_APP_ID,
            measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
        };

        app = initializeApp(firebaseConfig);
        
        // Initialize Analytics only if supported
        isSupported()
            .then((yes) => {
                if (yes && app) {
                    analytics = getAnalytics(app);
                }
            })
            .catch((err) => {
                // Silently handle analytics errors - they're not critical
                if (process.env.NODE_ENV === 'development') {
                    console.debug('Analytics support check failed:', err);
                }
            });
    } catch (error) {
        // Silently handle initialization errors - compat SDK is used for messaging
        if (process.env.NODE_ENV === 'development') {
            console.debug('Firebase Analytics initialization failed:', error);
        }
    }
}

export { analytics };